import React from 'react';
import { FormGroup, RadioButtonGroup, RadioButton } from 'carbon-components-react';

const RadioFormControl = (props) => {
  const onChange = value => {
    props.onChange(value);
  };

  return (
    <FormGroup legendText={props.schema.title}>
      <RadioButtonGroup
        name={props.name}
        defaultSelected={props.formData}
        onChange={onChange}
      >
        {props.schema.enum.map((option, i) => (
          <RadioButton
            id={`${props.idSchema.$id}-option-${i}`}
            key={`${props.idSchema.$id}-option-${i}`}
            labelPosition='right'
            labelText={props.schema.enumNames[i]}
            value={option}
          />
        ))}
      </RadioButtonGroup>
    </FormGroup>
  );
};

export default RadioFormControl;
